import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css'; // ¡Agrega esta línea!
import { Button, InputGroup,Form, Table } from "react-bootstrap";
import { list_QRs, move_links_to_folder, newLink } from "../../../utils/crm_services";
import './QRshorter.css';
import GeneradorQR from "./modals/GeneradorQR";
import Modal_proyectos from "../../menus/Modal";

function QRshorter({setactivity, permission}) {

    const token = localStorage.getItem("token");
    const navigate = useNavigate();   
    const [initialRows, setInitialRows] = useState([]);
    const [searchTerm, setSearchTerm] = useState(''); // Estado para el filtro de búsqueda
    const [currentFolder, setCurrentFolder] = useState(null); // null = raiz
    const [isModalOpen, setModalOpen] = useState(false);
    const [urlDestino, seturlDestino] = useState('');
    const [inputType, setInputType] = useState('longWord'); // Estado inicial
    const [newTitle, setTitle] = useState('');
    const [newLongURL, setlongURL] = useState('');
    const [newshortURL, setshortURL] = useState('');
    const [selectedIds, setSelectedIds] = useState([]);
    const [targetFolder, setTargetFolder] = useState('');
    const [isRootTarget, setIsRootTarget] = useState(false);
    const [isMoving, setIsMoving] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [shortURLError, setShortURLError] = useState('');

const [selectedFile, setSelectedFile] = useState(null); // Nuevo estado para el archivo

     const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

       useEffect(() => {
          fetchlistQRs();
        }, [token]); 

  const shortURLExists = (value) => {
    const v = (value ?? '').toString().trim().toLowerCase();
    if (!v) return false;
    return initialRows.some((row) => (row.short_url ?? '').toString().toLowerCase() === v);
  };

  async function newURLshort() {
    const shortTrimmed = (newshortURL ?? '').toString().trim();
    if (shortTrimmed && shortURLExists(shortTrimmed)) {
      setShortURLError('Ese Short Word ya existe. Elige otro.');
      return;
    }
    setShortURLError('');
    const newLinkresult = await newLink(token, newTitle, newLongURL, newshortURL, selectedFile);
    if (newLinkresult === "INVALID") {
      navigate("/");
    } else {
      setTitle('');
      setlongURL('');
      setshortURL('');
      setShortURLError('');
      fetchlistQRs();
    }
  }


  async function fetchlistQRs() {
              const linksList = await list_QRs(token);
              if (linksList==="INVALID"){
                  navigate("/");
              }else{
               
                 const tempList= linksList.map((celement, index) => {
                  const folderValue = (celement.folder ?? '').toString().trim();
                  return {
                    id: celement.id,
                    title: celement.title,
                    full_url: celement.full_url,
                    short_url: celement.short_url,
                    creation_date: celement.creation_date,
                    usr_creator_name: celement.usr_creator_name,
                    folder: folderValue,
                    index:index
                  };
                });
  
             
           
                  
                setInitialRows(tempList);
                
              }
            }

  // Filtrar las filas según el término de búsqueda y el Short Word (sin importar carpeta)
  const shortWordFilter = (newshortURL ?? '').toString().trim().toLowerCase();
  const filteredRows = initialRows.filter((row) => {
    const searchLower = searchTerm.toLowerCase();
    const matchSearch =
      !searchTerm ||
      row.title?.toLowerCase().includes(searchLower) ||
      row.full_url?.toLowerCase().includes(searchLower) ||
      row.short_url?.toLowerCase().includes(searchLower) ||
      row.usr_creator_name?.toLowerCase().includes(searchLower);
    const matchShortWord =
      !shortWordFilter || (row.short_url ?? '').toString().toLowerCase().includes(shortWordFilter);
    return matchSearch && matchShortWord;
  });

  const folderNames = Array.from(
    new Set(
      initialRows
        .map((row) => row.folder)
        .filter((folder) => folder)
    )
  ).sort((a, b) => a.localeCompare(b));

  const visibleRows = searchTerm
    ? filteredRows
    : currentFolder
      ? filteredRows.filter((row) => row.folder === currentFolder)
      : filteredRows.filter((row) => !row.folder);

  const toggleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
      }
      return { key, direction: 'asc' };
    });
  };

  const sortedRows = (() => {
    if (!sortConfig.key) {
      return visibleRows;
    }
    const sorted = [...visibleRows].sort((a, b) => {
      if (sortConfig.key === 'creation_date') {
        const dateA = a.creation_date ? new Date(a.creation_date) : new Date(0);
        const dateB = b.creation_date ? new Date(b.creation_date) : new Date(0);
        return dateA - dateB;
      }
      const valueA = (a[sortConfig.key] ?? '').toString().toLowerCase();
      const valueB = (b[sortConfig.key] ?? '').toString().toLowerCase();
      if (valueA < valueB) return -1;
      if (valueA > valueB) return 1;
      return 0;
    });
    return sortConfig.direction === 'asc' ? sorted : sorted.reverse();
  })();

  const sortIcon = (key) => {
    if (sortConfig.key !== key) {
      return null;
    }
    return sortConfig.direction === 'asc' ? ' ▲' : ' ▼';
  };

  const hasVisibleSelection = visibleRows.some((row) => selectedIds.includes(row.id));
  const allVisibleSelected = visibleRows.length > 0 && visibleRows.every((row) => selectedIds.includes(row.id));

  const toggleSelectAllVisible = (shouldSelect) => {
    if (shouldSelect) {
      const visibleIds = visibleRows.map((row) => row.id);
      setSelectedIds((prev) => Array.from(new Set([...prev, ...visibleIds])));
    } else {
      const visibleIds = new Set(visibleRows.map((row) => row.id));
      setSelectedIds((prev) => prev.filter((id) => !visibleIds.has(id)));
    }
  };

  const toggleSelectRow = (id) => {
    setSelectedIds((prev) => (
      prev.includes(id)
        ? prev.filter((currentId) => currentId !== id)
        : [...prev, id]
    ));
  };

  const moveSelectedToFolderTo = async (folderValue, rootTarget = false) => {
    if ((folderValue === '' && !rootTarget) || selectedIds.length === 0) {
      return;
    }
    setIsMoving(true);
    const result = await move_links_to_folder(token, selectedIds, rootTarget ? '' : folderValue);
    setIsMoving(false);
    if (result === "INVALID") {
      navigate("/");
      return;
    }
    setSelectedIds([]);
    setTargetFolder('');
    setIsRootTarget(false);
    fetchlistQRs();
  };

  const moveSelectedToFolder = async () => {
    await moveSelectedToFolderTo(targetFolder, isRootTarget);
  };

  return (
    <div className="container-fluid p-4">


       <Modal_proyectos isOpen={isModalOpen} onClose={() => setModalOpen(false)} 
              title="QR Code"
          >  
                     <GeneradorQR urlDestino={urlDestino } />

          </Modal_proyectos>

       <div className="d-flex align-items-center mb-4 gap-3">
        <h1 className="fw-bold mb-0">Shorter and QR generator</h1>
        <a href={"https://lookerstudio.google.com/u/0/reporting/9556647f-3187-47cf-a978-2bf7a7889d20/page/z0jcF"} target="_blank" className="btn btn-outline-dark btn-sm">
                  📊
                </a>
       </div>

        {/* Campo de búsqueda */}
        <div className="mb-3 mt-3">
          <Form.Group controlId="formSearch">
            <Form.Label>Buscar:</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <i className="bi bi-search"></i>
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Buscar por título, URL, creador..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <Button 
                  variant="outline-secondary" 
                  onClick={() => setSearchTerm('')}
                >
                  <i className="bi bi-x"></i>
                </Button>
              )}
            </InputGroup>
          </Form.Group>
        </div>

        <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-end' }}> {/* Contenedor flex para espaciado */}
      <div className="d-flex align-items-center mb-3">
                    <Form.Check
                        type="radio"
                        label="Short Word"
                        name="inputOption"
                        id="radio-short-word"
                        value="longWord"
                        checked={inputType === 'longWord'}
                        onChange={(e) =>{
                          setInputType(e.target.value);
                          setSelectedFile(null); 
                        } }
                        className="me-3"
                    />
                    <Form.Check
                        type="radio"
                        label="Upload File"
                        name="inputOption"
                        id="radio-upload-file"
                        value="fileUpload"
                        checked={inputType === 'fileUpload'}
                        onChange={(e) => setInputType(e.target.value)}
                    />
                </div>
                  {/* Campo de Título */}
                <Form.Group controlId="formTitle" className="flex-grow-1">
                  <Form.Label>Title:</Form.Label>
                  <Form.Control
                    placeholder="Title"
                    onChange={(e) => setTitle(e.target.value)}
                    value={newTitle}
                    className='toolbar-control'
                  />
                </Form.Group>

           
               


                {inputType === 'longWord' ? (
                  // Campo para Long Word
                  <Form.Group controlId="formShortUrl" className="flex-grow-1">
                      <Form.Label>Long Link:</Form.Label>
                      <Form.Control
                          placeholder="Long Link"
                          onChange={(e) => setlongURL(e.target.value)}
                          value={newLongURL}
                          className='toolbar-control'
                      />
                  </Form.Group>
              ) : (
                  // Campo para subir un archivo
                  <Form.Group controlId="formFile" className="flex-grow-1">
                      <Form.Label>Upload File:</Form.Label>
                      <Form.Control
                          type="file"
                          onChange={handleFileChange}
                          className='toolbar-control'
                      />
                  </Form.Group>
              )}

                {/* Campo de Short URL */}
                <Form.Group controlId="formShortUrl" className="flex-grow-1">
                  <Form.Label>Short Word:</Form.Label>
                  <Form.Control
                    placeholder="Short Word (la tabla se filtra por lo que escribas)"
                    onChange={(e) => {
                      setshortURL(e.target.value);
                      setShortURLError('');
                    }}
                    value={newshortURL}
                    className={`toolbar-control ${shortURLError ? 'is-invalid' : ''}`}
                  />
                
                </Form.Group>

                {/* Botón */}
                <Button
                  variant="primary"
                  className="d-flex align-items-center toolbar-control"
                  onClick={() => newURLshort()}
                >
                  Crear
                </Button>
        </div>
      
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 mt-3 gap-2">
          <div className="d-flex flex-wrap align-items-center gap-2">
            {currentFolder && !searchTerm && (
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setCurrentFolder(null)}
              >
                ← Volver a la raíz
              </Button>
            )}
            {currentFolder && !searchTerm && (
              <span className="text-muted">Carpeta: {currentFolder}</span>
            )}
            {searchTerm && (
              <span className="text-muted">Buscando en todos los registros</span>
            )}
            {shortWordFilter && (
              <span className="text-muted">Filtrando por Short Word: «{newshortURL.trim()}»</span>
            )}
            {!searchTerm && !currentFolder && folderNames.length > 0 && (
              <div className="d-flex flex-wrap gap-2">
                {folderNames.map((folder) => (
                  <Button
                    key={folder}
                    variant="outline-dark"
                    size="sm"
                    onClick={() => setCurrentFolder(folder)}
                  >
                    <i className="bi bi-folder me-1"></i>
                    {folder}
                  </Button>
                ))}
              </div>
            )}
          </div>
          <div className="d-flex align-items-center gap-2">
            <Form.Select
              size="sm"
              value={isRootTarget ? '__ROOT__' : targetFolder}
              onChange={(e) => {
                const selectedValue = e.target.value;
                if (selectedValue === '__NEW__') {
                  const newFolderName = window.prompt('Nombre de la nueva carpeta:');
                  if (newFolderName && newFolderName.trim()) {
                    const trimmedName = newFolderName.trim();
                    setTargetFolder(trimmedName);
                    setIsRootTarget(false);
                    if (selectedIds.length > 0) {
                      moveSelectedToFolderTo(trimmedName, false);
                    }
                  } else {
                    setTargetFolder('');
                    setIsRootTarget(false);
                  }
                  return;
                }
                if (selectedValue === '__ROOT__') {
                  setTargetFolder('');
                  setIsRootTarget(true);
                  return;
                }
                setTargetFolder(selectedValue);
                setIsRootTarget(false);
              }}
              style={{ minWidth: 200, height: '31px' }}
            >
              <option value="">Mover a carpeta...</option>
              <option value="__ROOT__">Raíz (sin carpeta)</option>
              <option value="__NEW__">Nueva carpeta…</option>
              {folderNames.map((folder) => (
                <option key={folder} value={folder}>
                  {folder}
                </option>
              ))}
            </Form.Select>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={moveSelectedToFolder}
              disabled={(targetFolder === '' && !isRootTarget) || selectedIds.length === 0 || isMoving}
              className="text-nowrap"
              style={{ minWidth: 170, height: '31px' }}
            >
              {isMoving ? "Moviendo..." : "Mover seleccionados"}
            </Button>
            {hasVisibleSelection && (
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setSelectedIds([])}
                className="text-nowrap"
                style={{ minWidth: 150, height: '31px' }}
              >
                Limpiar selección
              </Button>
            )}
          </div>
        </div>

        <Table hover responsive className="align-middle">
          <thead className="table-light">
            <tr>
                <th style={{ width: 36 }}>
                  <Form.Check
                    type="checkbox"
                    checked={allVisibleSelected}
                    onChange={(e) => toggleSelectAllVisible(e.target.checked)}
                  />
                </th>

                <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('title')}>
                  Title{sortIcon('title')}
                </th>

              
                <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('full_url')}>
                  Long{sortIcon('full_url')}
                </th>

              <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('short_url')}>
                  Short{sortIcon('short_url')}
                </th>


                <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('usr_creator_name')}>
                  Created by{sortIcon('usr_creator_name')}
                </th>

                <th style={{ cursor: 'pointer', minWidth: 140 }} onClick={() => toggleSort('creation_date')}>
                  Created at{sortIcon('creation_date')}
                </th>

                
            </tr>
          </thead>
          <tbody>
            {sortedRows.map((row) => {

              return(
              <tr>
               <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedIds.includes(row.id)}
                    onChange={() => toggleSelectRow(row.id)}
                  />
                </td>
               <td>{row.title} </td>
               <td>
                  <a href={row.full_url} target="_blank">
                      {row.full_url && row.full_url.length > 25
                                ? row.full_url.slice(0, 25) + '...'
                                : row.full_url}
                                </a> 
                                </td>
               <td>
                  <div className="d-flex justify-content-between align-items-center">
                    {/* Texto/Enlace a la izquierda */}
                    <a href={"https://tomi.la/" + row.short_url} target="_blank" rel="noopener noreferrer">
                      {"tomi.la/" + row.short_url}
                    </a>

                    {/* Botones a la derecha */}
                    <div className="btn-group" role="group" aria-label="Acciones de URL">
                      <button
                        className="btn btn-outline-tomi-dark btn-sm" // Aplicamos la nueva clase de color y 'btn-sm'
                        onClick={() => {
                          navigator.clipboard.writeText("https://tomi.la/" + row.short_url);
                          alert('URL corta copiada al portapapeles!');
                        }}
                        title="Copiar URL"
                      >
                        <i className="bi bi-copy"></i>
                      </button>
                      <button
                        className="btn btn-outline-tomi-green btn-sm" // Aplicamos la nueva clase de color y 'btn-sm'
                        onClick={() => {
                          // Lógica para generar el QR
                          seturlDestino("https://tomi.la/" + row.short_url);
                         setModalOpen(true);
                        }}
                        title="Generar QR"
                      >
                        <i className="bi bi-qr-code"></i>
                      </button>
                    </div>
                  </div>
                </td>
                
                <td>{row.usr_creator_name}</td>
                <td>{row.creation_date}</td>
      
              </tr>
            )})}
            {sortedRows.length === 0 && (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  No results
                </td>
              </tr>
            )}
          </tbody>
        </Table>

       
      
         
    </div>
  );
}

export default QRshorter;